import { render } from "./PauseGame.vue?vue&type=template&id=2d8bc845"
import script from "./PauseGame.vue?vue&type=script&lang=js"
export * from "./PauseGame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__